<header class="text-white py-3 shadow-sm">
   <div class="container-fluid px-4">
      <div class="d-flex align-items-center justify-content-between">

         <!-- Left side: Logo + Brand -->
         <div class="d-flex align-items-center">
            <img src="/assets/images/icons/swa-icon.png"
                 alt="SW Icon"
                 class="brand-logo me-2">
            <h1 class="h4 mb-0">Learning Portal Customer Service</h1>
         </div>

         <!-- Right side: User -->
         @if(user()){

         <div class="user dropdown">
            <a href="#"
               class="d-block text-decoration-none text-white dropdown-toggle"
               id="siteHeaderUserMenu"
               data-bs-toggle="dropdown"
               aria-expanded="false">
               {{user().displayName}}
            </a>
            <ul class="dropdown-menu dropdown-menu-end text-small" aria-labelledby="siteHeaderUserMenu">
               <li><a href="javascript:void(0)" class="dropdown-item fw-bold pointable" (click)="goToSearch()">Search</a></li>
               <li><hr class="dropdown-divider"></li>
               <li><span class="dropdown-item pointable" (click)="logout()">Sign Out</span></li>
            </ul>
         </div>
         }

      </div>
   </div>
</header>
